import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import ErrorBoundary from "@/components/ErrorBoundary";

// Suppress browser extension and cross-origin errors
window.addEventListener('error', (e) => {
  const msg = (e.message || '').toLowerCase();
  const src = (e.filename || '').toLowerCase();
  // Firefox reader mode, Brave, Chrome extensions, cross-origin script errors
  if (
    msg.includes('__firefox__') || msg.includes('firefox') ||
    msg.includes('__crweb') || msg.includes('crweb') ||
    msg.includes('reader') ||
    msg.includes('youtube') ||
    msg.includes('extension') ||
    msg.includes('script error') ||
    msg.includes("can't find variable") ||
    msg.includes('is not defined') ||
    msg.includes('resizeobserver') ||
    src.includes('extension') ||
    src.includes('chrome-extension') ||
    src.includes('moz-extension') ||
    e.filename === '' || e.filename === null
  ) {
    e.preventDefault();
    e.stopPropagation();
    return true;
  }
});

window.addEventListener('unhandledrejection', (e) => {
  const msg = (e.reason?.message || e.reason || '').toString().toLowerCase();
  if (
    msg.includes('__firefox__') || msg.includes('firefox') ||
    msg.includes('__crweb') || msg.includes('crweb') ||
    msg.includes('reader') ||
    msg.includes('script error') ||
    msg.includes("can't find variable") ||
    msg.includes('extension') ||
    msg.includes('resizeobserver')
  ) {
    e.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);
